module.exports = __webpack_public_path__ + "media/meditation_2.12ef2f22.webm";